import './ModalWrapper.sass';

import React, { FC, useEffect } from 'react';
import { ModalWrapperProps } from './ModalWrapper.interface';
import { classNames } from '$utils';
import { useModalWrapper } from '$hooks';

export const ModalWrapper: FC<ModalWrapperProps> = ({
  onOverlayClick,
  name,
  children,
  aboveAll,
}) => {
  const canCloseModal = useModalWrapper(name);

  useEffect(() => {
    const handleEscaping = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && onOverlayClick && canCloseModal()) {
        onOverlayClick(e);
      }
    };

    window.addEventListener('keydown', handleEscaping);
    return () => window.removeEventListener('keydown', handleEscaping);
  }, [onOverlayClick]);

  return (
    <div
      className={classNames({
        Modal__wrap: true,
        aboveAll,
        isPhotos: name.substring(0, 6) === 'photos',
      })}
      onClick={(e) => {
        if (e.target === e.currentTarget && onOverlayClick && canCloseModal()) {
          onOverlayClick(e);
        }
      }}
    >
      <div
        className={classNames({
          Modal__cont: true,
          noScroll: ['edit_countries', 'edit_content_priority'].includes(name),
          smallWidth: ['user_info'].includes(name),
        })}
      >
        {children}
      </div>
    </div>
  );
};
